<template lang="pug">
  div(class="d-flex align-center flex-wrap justify-center")
    span(
      class="pagination"
      data-test="pagination-info-text"
      :class="{ 'pr-3': !shownMassActions || xlDevice }"
    ) {{ pagination.pageStart }}-{{ pagination.pageStop }}
      span(v-if="isApiReturnFullTotalItems" class="pl-1") {{ $t('from') }} {{ totalItems }}
    div(class="d-flex align-center")
      v-btn(
        icon
        class="pagination-arrow"
        data-test="pagination-prev-btn"
        :disabled="disablePrev"
        @click="$emit('prev')"
      )
        e-svg-icon arrow-left-gray
      v-btn(
        icon
        class="pagination-arrow"
        data-test="pagination-next-btn"
        :disabled="pagination.disableNext"
        @click="$emit('next')"
      )
        e-svg-icon arrow-right-gray
</template>

<script>
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'MBlockTablePagination',
  mixins: [responsive],
  props: {
    meta: {
      type: Object,
      default: () => ({})
    },
    shownMassActions: {
      type: Boolean,
      default: false
    },
    isApiReturnFullTotalItems: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    totalItems() {
      return this.meta?.totalItems
    },
    maxPageWithoutFullTotalItems() {
      return this.totalItems <= this.meta?.itemsPerPage
    },
    maxPage() {
      return Math.ceil(this.meta?.totalItems / this.meta?.itemsPerPage)
    },
    pageStart() {
      if (this.meta?.currentPage > 1) {
        return (this.meta?.currentPage - 1) * this.meta?.itemsPerPage + 1
      }
      return 1
    },
    pageStopWithoutFullTotalItems() {
      if (this.maxPageWithoutFullTotalItems) {
        return (this.meta?.currentPage - 1) * this.meta?.itemsPerPage + this.totalItems
      }
      return this.meta?.currentPage * this.meta?.itemsPerPage
    },
    pageStop() {
      return this.maxPage > this.meta?.currentPage
        ? this.meta?.currentPage * this.meta?.itemsPerPage
        : this.meta?.totalItems
    },
    disableNext() {
      return this.meta?.currentPage >= this.maxPage
    },
    disableNextWithoutFullTotalItems() {
      return this.maxPageWithoutFullTotalItems
    },
    disablePrev() {
      return this.meta?.currentPage <= 1
    },
    pagination() {
      if (this.isApiReturnFullTotalItems) {
        return {
          pageStart: this.pageStart,
          pageStop: this.pageStop,
          disableNext: this.disableNext
        }
      } else {
        return {
          pageStart: this.pageStart,
          pageStop: this.pageStopWithoutFullTotalItems,
          disableNext: this.disableNextWithoutFullTotalItems
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pagination {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;

  &-arrow {
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 0 4px;

    width: 32px;
    height: 32px;
    background: rgba(0, 0, 0, 0.03);
  }
}
</style>
